import { useProductSummaryName } from '../hooks/useProductSummaryName';

const ProductReference = () => {
	const { blockClass } = useProductSummaryName();

	return (
		<span
			className={`productReference productReference--${blockClass}  vtex-product-summary-2-x-productReference vtex-product-summary-2-x-productReference--${blockClass}`}
		>
			REF: 123456
		</span>
	);
};

export default ProductReference;
